// src/App.js
import "../src/assets/styles/global.css";
import { Route, Routes } from 'react-router-dom';
import EPSSCalculator from './pages/EPSSCalculator';
// import FirebaseUIComponent from "./FirebaseUIComponent";

// Import Firebase initialization
// import './firebase'; // Make sure this is imported before using FirebaseUIComponent

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<EPSSCalculator />} />
        {/* <Route path="/login" element={<FirebaseUIComponent />} /> */}
      </Routes>
    </>
  );
}

export default App;
